import React, { useContext, useMemo, useState } from 'react'
import { Pen, Trash } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../../contexts/InfluencerContext'
import Authentication from '../../../../../models/Authentication'
import { formatNumber, formatProvider } from '../../../../../utils/Helper'
import InfluencerModal from './InfluencerModal'
import RemoveAuthenticationModal from './RemoveAuthenticationModal'

export default function AuthenticationSection() {
  const [modalOpen, setModalOpen] = useState(false)
  const [removeModalOpen, setRemoveModalOpen] = useState(false)
  const { id } = useParams()
  const { authentications } = useContext(InfluencerContext)

  const currentAuthentication = useMemo(() => authentications.find(authentication => +authentication.id === +id ) || new Authentication(), [id, authentications, authentications.length] )

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-xl">
      <div className="flex justify-between">
        <p className="font-bold text-xl mb-4 dark:text-white">{formatProvider(currentAuthentication.provider)} Authentication</p>
        <div className="flex items-center gap-4">
          <button className="font-bold text-sm flex items-center dark:text-white" onClick={() => setModalOpen(true)}><Pen />Change Influencer</button>
          <button className="font-bold text-sm flex items-center text-red-500" onClick={() => setRemoveModalOpen(true)}><Trash />Remove</button>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-between">
          <p className="dark:text-white">Username:</p>
          <p className="font-bold dark:text-white">{currentAuthentication.username}</p>
        </div>
        <div className="flex items-center justify-between">
          <p className="dark:text-white">Followers:</p>
          <p className="font-bold dark:text-white">{formatNumber(currentAuthentication.reach)}</p>
        </div>
      </div>
      {modalOpen && <InfluencerModal modalOpen={modalOpen} setModalOpen={setModalOpen} />}
      {removeModalOpen && <RemoveAuthenticationModal modalOpen={removeModalOpen} setModalOpen={setRemoveModalOpen} authentication={currentAuthentication} />}
    </div>
  )
}